<template>
  <div class="mx-auto w-full max-w-[28rem] space-y-4 rounded-lg bg-white p-8 text-center">
    <h1 class="font-medium">{{ t('pausedTitle') }}</h1>
    <p>{{ t('pausedText') }}</p>
    <CVButton class="w-full" :is-loading="isResuming" @click="handleContinue">
      {{ t('continueHandover') }}
    </CVButton>
  </div>
</template>

<script lang="ts" setup>
import { ref } from 'vue';
import { useI18n } from 'vue-i18n';
import CVButton from '@/components/buttons/CVButton.vue';

/** Shown to an External driver while the station has taken over their handover (ADR 0021). */
const props = defineProps<{
  resume: () => Promise<void>;
}>();

const { t } = useI18n();
const isResuming = ref(false);

async function handleContinue() {
  isResuming.value = true;
  try {
    await props.resume();
  } finally {
    isResuming.value = false;
  }
}
</script>

<i18n lang="json">
{
  "en": {
    "pausedTitle": "The station is handling this handover",
    "pausedText": "Someone from the station has taken over the handover, e.g. to make a change. Continue once they tell you to; your progress is kept.",
    "continueHandover": "Continue handover"
  },
  "de": {
    "pausedTitle": "Die Station übernimmt gerade",
    "pausedText": "Jemand von der Station hat die Übergabe übernommen, z. B. um etwas zu ändern. Mach weiter, sobald sie dir Bescheid gibt; dein Fortschritt bleibt erhalten.",
    "continueHandover": "Übergabe fortsetzen"
  },
  "es": {
    "pausedTitle": "La estación se está ocupando de esta entrega",
    "pausedText": "Alguien de la estación ha tomado el control de la entrega, por ejemplo para hacer un cambio. Continúa cuando te avisen; tu progreso se mantiene.",
    "continueHandover": "Continuar entrega"
  }
}
</i18n>
